import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=71e63a78&scoped=true&"
import script from "./ResetView.vue?vue&type=script&lang=js&"
export * from "./ResetView.vue?vue&type=script&lang=js&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=71e63a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e63a78",
  null
  
)

export default component.exports